<template>
  <div class="predicted-apply-detail-page main-layout">
    <el-card class="box-inner">
      <c-title slot="header" title="详情" :back="true" />
      <div class="div-scroll">
        <div class="detail-container">
          <el-row>
      <el-col :span="4">学号</el-col>
      <el-col :span="20">{{ detailInfo.studentNo }}</el-col>
    </el-row>
          <el-row>
            <el-col :span="4">身份证号</el-col>
            <el-col :span="20">{{ detailInfo.idCard }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">姓名</el-col>
            <el-col :span="20">{{ detailInfo.studentName }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">学院</el-col>
            <el-col :span="20">{{ detailInfo.collegeName }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">系别</el-col>
            <el-col :span="20">{{ detailInfo.departmentName }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">专业</el-col>
            <el-col :span="20">{{ detailInfo.majorName }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">班级</el-col>
            <el-col :span="20">{{ detailInfo.className }}</el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="4">缓缴内容</el-col>
            <el-col :span="20">
              {{ detailInfo.isTuition == 1 ? "学费" : "" }}
              {{ detailInfo.isDormitory == 1 ? "、住宿费" : "" }}
              {{
                detailInfo.isOther == 1
                  ? "、其他费用(材料费、体检费、军训服费用等)"
                  : ""
              }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">缓缴原因</el-col>
            <el-col :span="20">{{ detailInfo.reason }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">最晚缴纳时间</el-col>
            <el-col :span="20">{{ detailInfo.endTime }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">是否贷款</el-col>
            <el-col :span="20">{{
              detailInfo.isLoan == 1 ? "是" : "否"
            }}</el-col>
          </el-row> -->
          <el-row>
            <el-col :span="4">贷款金额</el-col>
            <el-col :span="20">{{ detailInfo.loanAmount }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">回执校验码</el-col>
            <el-col :span="20">{{ detailInfo.receiptCode }}</el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="4">申请表</el-col>
            <el-col :span="20">
              <div class="form-img-item img-item">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="detailInfo.formUrl"
                  :preview-src-list="[detailInfo.formUrl]"
                >
                </el-image>
              </div>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">《生源地贷款合同》或受理证明等相关资料：</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="img-row">
              <div
                class="evidence-img-item img-item"
                v-for="(item, index) in detailInfo.pictureUrl"
                :key="index"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item"
                  :preview-src-list="detailInfo.pictureUrl"
                >
                </el-image>
              </div>
            </el-col>
          </el-row>
          <!-- <div class="operation-btn" v-if="type == 'todo'">
            <el-button
              type="success"
              @click="handleChange(4)"
              :disabled="isSubmit"
              >通过</el-button
            >
            <el-button
              type="danger"
              @click="handleChange(2)"
              :disabled="isSubmit"
              >驳回</el-button
            >
          </div> -->
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SUCCESS_CODE: "",
      detailInfo: {},
      type: "",
      isSubmit: false,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    let id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.getDetailInfo(id);
  },
  mounted() {},
  methods: {
    getDetailInfo(id) {
      this.$http
        .get("/welcome-live/green/apply/" + id)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            if (res.data) {
              this.detailInfo = res.data;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 处理申请
    handleChange(status) {
      this.$confirm("请确认无误后提交，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isSubmit = true;
          let params = {
            forecastLinkId: this.detailInfo.forecastLinkId,
            studentId: this.detailInfo.studentId,
            status,
          };
          this.$http
            .post("/welcome-live/green/apply/change", params)
            .then((res) => {
              if (res.code == this.SUCCESS_CODE) {
                this.$message.success("操作成功");
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
              this.isSubmit = false;
            })
            .catch((err) => {
              this.isSubmit = false;
              this.$message.error(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>
